module.exports = __webpack_public_path__ + "static/case-travis-2@2x.bdee17dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/case-travis-2@2x.png
// module id = 177
// module chunks = 35783957827783 43201937662106